/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.app.permissions.hublets.app.auth.rpc.AppPermissionsHubletsAppAuthRpc
 */

export const getAvailableAppPermissionsReplicatedRpc = {
  serviceName: 'com.hubspot.app.permissions.hublets.app.auth.rpc.AppPermissionsHubletsAppAuthRpc',
  rpcName: 'getAvailableAppPermissionsReplicated',
  auth: 'app',
  fingerprint: 'q4BOJMoHzQK2sOLeiU1QTgxAsniWr2JX',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getAppPermissionsByResourceTypeReplicatedRpc = {
  serviceName: 'com.hubspot.app.permissions.hublets.app.auth.rpc.AppPermissionsHubletsAppAuthRpc',
  rpcName: 'getAppPermissionsByResourceTypeReplicated',
  auth: 'app',
  fingerprint: 'z93cVXdb3KfspGLxqppkUQxAsniWr2JX',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getAppPermissionTranslationsRpc = {
  serviceName: 'com.hubspot.app.permissions.hublets.app.auth.rpc.AppPermissionsHubletsAppAuthRpc',
  rpcName: 'getAppPermissionTranslations',
  auth: 'app',
  fingerprint: 'KW3la1jaOsmCg8a8fHl1VgxAsniWr2JX',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};